import { connect } from "react-redux";

import { Creators } from "./reducer";

import LoginPage from "./components/LoginPage";

export default connect(
  state => ({
    loginFailedMessage: state.login.loginFailedMessage,
    user: state.login.user,
    mode: state.login.mode,
    location: state.login.location,
    locations: state.data.locations,
    username: state.login.username
  }),
  dispatch => ({
    onLogin: (username, password, location, mode) => {
      dispatch(Creators.loginRequest(username, password, location, mode));
    }
  })
)(LoginPage); // LoginPage uses locations, but since its globally required AppRouter loads it.



// WEBPACK FOOTER //
// ./src/login/index.js